import glamorous from 'glamorous';
import DownChevronIcon from '../../../shared/library/icons/chevron-down-icon.svg';
import {BLACK, TARMAC, WHITE} from '../../../shared/style/colors';

export const ChevronIcon = glamorous(DownChevronIcon)({
  width: 12,
  height: 12,
  fill: TARMAC
});

export const ChevronIconUp = glamorous(DownChevronIcon)({
  width: 12,
  height: 12,
  transform: 'rotate(180deg)',
  fill: TARMAC
});

export const ChevronRightIcon = glamorous(DownChevronIcon)({
  width: 12,
  height: 12,
  transform: 'rotate(270deg)',
  fill: TARMAC
});

export const Table = glamorous.table({
  width: '100%',
  borderLeft: '1px solid #f0f0f0',
  borderRight: '1px solid #f0f0f0',
  borderBottom: '1px solid #f0f0f0',
  tableLayout: 'fixed',
  position: 'relative',
  ' th': {
    background: '#fafafa',
    color: '#424242',
    padding: '15px 0',
    borderBottom: '1px solid #f0f0f0',
    borderTop: '1px solid #f0f0f0',
    textTransform: 'uppercase',
    paddingLeft: 20
  },
  ' tr': {
    position: 'relative'
  },
  ' td': {
    position: 'relative'
  }
});

export const Count = glamorous.span({
  background: BLACK,
  color: WHITE,
  textAlign: 'center',
  minWidth: 25,
  display: 'inline-block',
  marginLeft: 5,
  borderRadius: 25,
  padding: '2px 7px',
  fontSize: 12
});

export const SingleColumn = glamorous.td({
  fontWeight: 'normal',
  display: 'flex',
  alignItems: 'center',
  ' > svg': {
    marginRight: 10,
    height: 32,
    width: 32
  }
});

export const VersionTd = glamorous.td({
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  padding: '15px 5px',
  color: TARMAC,
  fontSize: 14,
  cursor: 'pointer',
  ' > svg': {
    marginRight: 10
  }
});

export const VersionTr = glamorous.tr({
  '&:hover': {
    background: '#f9f9f9',
    cursor: 'pointer'
  }
});
